/* Wat een taalmodel per token kost. Het CRM krijgt van NATS alleen tokens; het bedrag op de pagina
 * "Mail en AI" is tokens maal dit tarief en dus een schatting. De rekening zelf staat bij Google.
 * Verandert het tarief, voeg dan een regel toe met de dag waarop het ingaat; oude dagen houden zo
 * hun oude prijs. */

export interface Tarief {
  model: string;
  /** Eerste dag (YYYY-MM-DD) waarop dit tarief geldt; null = vanaf het begin. */
  vanaf: string | null;
  /** Dollars per miljoen tokens. Uit is inclusief de denk-tokens van het model. */
  inPerMiljoen: number;
  uitPerMiljoen: number;
}

export const TARIEVEN: Tarief[] = [
  { model: 'gemini-3.6-flash', vanaf: null, inPerMiljoen: 0.75, uitPerMiljoen: 3.75 },
  { model: 'gemini-3.6-flash', vanaf: '2027-01-01', inPerMiljoen: 1.5, uitPerMiljoen: 7.5 },
];

export const TARIEF_BRON = {
  naam: 'ai.google.dev/gemini-api/docs/pricing',
  url: 'https://ai.google.dev/gemini-api/docs/pricing',
  /** De dag waarop de tarieven hierboven zijn overgenomen. */
  gezien: '2026-10-02',
};

/** Het tarief dat op die dag voor dat model gold, of null als het model hier niet in staat. */
export function tariefVoor(model: string, dag: string, tarieven: Tarief[] = TARIEVEN): Tarief | null {
  let beste: Tarief | null = null;
  for (const t of tarieven) {
    if (t.model !== model || (t.vanaf !== null && t.vanaf > dag)) continue;
    if (!beste || (t.vanaf ?? '') >= (beste.vanaf ?? '')) beste = t;
  }
  return beste;
}
